import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { SnmpV3User } from 'data/snmp/snmp.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  snmpUserServerData: SnmpV3User,
  originalSnmpUserServerDataServerFormData: SnmpV3User | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.SNMP_USER_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SNMP_USER_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(snmpUserServerData, null, isEdit, originalSnmpUserServerDataServerFormData),
    snmpUserServerData.USERNAME,
    AuditService.SNMP_USER,
    actionType,
  );
  return auditDetails as AuditDetails;
}
